export default __webpack_public_path__ + "static/media/1.554967d2.jpg";